import { ErrorBaseData } from '.'

export const termErrors: Record<string, ErrorBaseData> = {
  SpecialtyTypeNotFoundException: {
    message: 'Especialidade não encontrada',
    description: 'Não foi possível encontrar a especialidade. Verifique as informações e tente novamente',
  },
}
